import { render } from "./invitationMainPage.vue?vue&type=template&id=43835ff6&scoped=true"
import script from "./invitationMainPage.vue?vue&type=script&lang=js"
export * from "./invitationMainPage.vue?vue&type=script&lang=js"

import "./invitationMainPage.vue?vue&type=style&index=0&id=43835ff6&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43835ff6"]])

export default __exports__